/*
 *
 * ReceptionDxGrid14852
 *
 */

import {AdminSkudDxGrid} from "pages/Requests/AdminSkud";
import {
    ACCESS_CARD_MAKE_OR_DENIED_REQUESTS,
    ACTIVE_REQUESTS,
    NOT_PASS_HAS_BEEN_MADE_ISSUED
} from "domain/Data/Filters/constants";
import {requestColumnSizes} from "domain/typeConstants/table";


export class AdminSkudDxGrid14852 extends AdminSkudDxGrid {

    getFilters() {
        const {viewName} = this.props;
        const filters = [ACCESS_CARD_MAKE_OR_DENIED_REQUESTS];

        if (viewName === 'active') {
            filters.push(ACTIVE_REQUESTS)
            filters.push(NOT_PASS_HAS_BEEN_MADE_ISSUED)
        }
        return filters;
    }


    getColumns() {
        const columns = super.getColumns();

        const blackListStyle = {
            style: {color: '#d50000'},
            condition: (value) => value.isBlackList,
        };
        const styles = [blackListStyle];

        columns.push({
            path: ['type', 'shortName'],
            name: 'typeShortName',
            getCellValue: (row) => (row.type ? row.type.shortName : undefined),
            title: 'Вид',
            entityName: 'requestTypes',
            width: requestColumnSizes.typeShortName,
            styles,
        })
        return columns;
    }

    getColumnOrder() {
        const columnOrder = super.getColumnOrder();
        const statusNameIndex = columnOrder.findIndex(columnName => columnName === 'statusName')
        columnOrder.splice(statusNameIndex + 1, 0, 'typeShortName');
        return columnOrder
    }

}
